import React from 'react'
import { Box, Toolbar, Typography } from "@mui/material";
import Footer from '../Component/Footer';
import { useLanguage } from '../context/LanguageContext';
import Header from "../Component/header";
import DesktopFooter from "../Component/Desktopfooter";
import Pform from "../Component/Pform";
const Paitentsform = () => {
  const { t } = useLanguage();
  return (
    <>
      <div className='text-Wrapper'>
<Header/>
        <Box>
        <Toolbar>
       <Pform/>
        </Toolbar>
        </Box>
      </div>
       <DesktopFooter/>
      <Footer />
    </>
  )
}

export default Paitentsform



